import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

const ThemeCtx = createContext({ theme: "light", setTheme: () => {} });

function applyTheme(theme) {
    const root = document.documentElement;
    if (theme === "dark") root.classList.add("dark");
    else root.classList.remove("dark");
}

export function ThemeProvider({ children }) {
    const [theme, setThemeState] = useState(() => localStorage.getItem("gms.theme") || "light");

    useEffect(() => {
        applyTheme(theme);
    }, [theme]);

    const setTheme = useCallback((t) => {
        localStorage.setItem("gms.theme", t);
        setThemeState(t);
    }, []);

    const value = useMemo(() => ({ theme, setTheme }), [theme, setTheme]);
    return <ThemeCtx.Provider value={value}>{children}</ThemeCtx.Provider>;
}

export const useTheme = () => useContext(ThemeCtx);
